<template>
  <a-row class="container-fluid container-wrap col-sm-12 col-xs-12">
    <a-row class="row justify-content-center">
      <a-row class="col-sm-12 col-xs-12">
        <a-row class="card-header pb-0 col-sm-12 d-flex mainDiv certiDiv event-div-wrap">
          <div class="col-sm-12 col-xs-12">
            <a-row class="col-sm-12 col-xs-12 titleDiv event-div-wrapTitle">
              <a-row class="col-sm-10">
                <h3>{{ $t('navbar_event_list') }}</h3><br>
              </a-row>
              <a-row class="col-sm-10">
                <h5>신규 이벤트를 등록해주세요.</h5>
              </a-row>
            </a-row>
            <a-row class="card-body px-0 pt-0 pb-2">
              <a-row class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h4>{{ $t('add_event_title') }}</h4>
                  <a-row class="add-event-container">
                    <!-- v-bind="formItemLayout" -->
                    <a-form
                        class="add-event-form"
                        style="width: 100%;"
                        name="event-form"
                        :model="formState"
                        :rules="rules"
                        @finish="uiHandler.onFinish"
                        @finishFailed="uiHandler.onFinishFailed"
                    >
                      <a-row class="add-event-row">
                        <a-form-item ref="eventDuration"
                          :colon="false"
                          name="eventDuration"
                        >
                          <template #label>
                            <form-label
                              labelTitle="이벤트 기간"
                              :isRequired="true"
                            />
                          </template>
                          <a-row style="width: 420px;">
                            <a-range-picker
                                :locale="locale"
                                v-model:value="formState.dateRanges"
                                show-time
                                format="YYYY-MM-DD HH:mm:ss"
                                value-format="YYYY-MM-DD HH:mm:ss"
                            />
                          </a-row>
                        </a-form-item>
                      </a-row>
                      <a-row class="add-event-row">
                        <a-form-item 
                          ref="eventHospital"
                          :colon="false"
                          name="eventHospital"
                        >
                          <template #label>
                            <form-label
                              labelTitle="이벤트 참여 병원"
                              :isRequired="true"
                            />
                          </template>
                          <a-table class="ant-table-striped"
                                  size="small"
                                  :row-selection="rowSelection"
                                  :columns="eventHospital.columns"
                                  :data-source="eventHospital.list"
                                  :scroll="{ x: true, y: 300 }"
                                  :pagination="false">
                            <template #emptyText>
                              <div class="noData">
                                <i class="fa-solid fa-exclamation-triangle"
                                  style="font-size: 24px; margin-bottom: 10px"/><br>
                                <span>{{ computedNoResultMessage }}</span>
                              </div>
                            </template>
                          </a-table>
                        </a-form-item>
                      </a-row>
               
                    </a-form>
                  </a-row>
              </a-row>
            </a-row>

            <a-row class="d-flex item-btn-area">
              <a-button
                  @click="$router.push('/events')"
                  class="certi-cancel-btn"
              >
                {{ $t('common_cancel') }}
              </a-button>
              <a-button
                  type="primary"
                  class="certi-submit-btn"
              >
                {{ $t('event_header_register') }}
              </a-button>
            </a-row>
          </div>
        </a-row>
      </a-row>
    </a-row>
  </a-row>
</template>
<script>
import eventApis from "@/views/EventManagement/api";
import dayjs from "dayjs";
import 'dayjs/locale/ko';
import locale from "ant-design-vue/es/date-picker/locale/ko_KR";
import FormLabel from "@/views/components/FormLabel.vue";
import {MedicalDept} from "@/utils/enums";
import {businessNumberFormatter, convertDateTime, formatCommaNumber, phoneNumberFormatter} from "@/utils/utils";

export default {
  components: {FormLabel},
  computed: {
    computedNoResultMessage() {
      return this.$i18n.t('noresult_hospital');
    },
    formItemLayout() {
      return {
        labelCol: {
          xs: {span: 24},
          sm: {span: 6},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 18},
        },
      }
    }
  },
  async mounted() {
    await this.apiHandler.getEventHospitals({page: 1, limit: 100, type: 'HOSPITAL'},
        (response) => {
          console.log("response==>", response.docs);
          this.eventHospital.list = response.docs.map((d, index) => {
            return {index: index + 1, ...d}
          })
        }, (error) => {
          console.log("error==>", error);
        })
  },
  data() {
    const today = dayjs()
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      businessNumberFormatter,
      formatCommaNumber,
      phoneNumberFormatter,
      convertDateTime,
      locale,
      deptList: [], //과목 목록
      formState: {
        dateRanges: [today, today]
      },
      rules: {
        eventDuration: [
          {
            type: 'array',
            required: true,
            message: '이벤트 기간을 선택해 주세요!',
          },
        ]
      },
      eventHospital: {
        list: [],
        columns: [
          {
            key: 'index', title: this.$t('productslist_table_no'), dataIndex: 'index', align: 'center', width: '50px'
          },
          {
            key: 'cNo', title: this.$t('hospital_search_cno'), dataIndex: 'cNo', align: 'start',
            customRender: ({text, record}) => {
              return this.businessNumberFormatter(record.cNo);
            },
          },
          {
            key: 'name', title: this.$t('hospital_table_name'), dataIndex: 'name', align: 'start',
            customRender: ({text, record}) => {
              return record.name ? record.name : '-';
            },
          },
          {
            key: 'warrantyCount',
            title: this.$t('hospital_table_nftsnumber'),
            dataIndex: 'warrantyCount',
            align: 'center',
            width: '100px',
            customRender: ({text, record}) => {
              return formatCommaNumber(record.warrantyCount)
            }
          },
          {
            key: 'formattedAddress',
            title: this.$t('hospital_table_region'),
            dataIndex: 'formattedAddress',
            align: 'start',
            customRender: ({text, record}) => {
              return this.uiHandler.formatAddress(record)
            },
          },
          {
            key: 'createAt', title: this.$t('hospital_table_createat'), dataIndex: 'createAt', align: 'start',
            customRender: ({text, record}) => {
              return convertDateTime(record.createAt)
            },
          },
          {
            key: 'accountInfo_name',
            title: this.$t('hospital_table_managername'),
            dataIndex: 'accountInfo_name',
            align: 'start',
            customRender: ({text, record}) => {
              return (
                  <div class="item-names-wrap justify-content-start">
                    {record.accountInfo_name.map((name) => (
                        <div class="item-names">{name || '-'}</div>
                    ))}
                  </div>
              )
            },
          },
          {
            key: 'accountInfo_mobile',
            title: this.$t('hospital_table_phone'),
            dataIndex: 'accountInfo_mobile',
            align: 'start',
            customRender: ({text, record}) => {
              return (
                  <div class="item-names-wrap justify-content-start">
                    {record.accountInfo_mobile.map((mobile) => (
                        <div class="item-names">{phoneNumberFormatter(mobile) || '-'}</div>
                    ))}
                  </div>
              )
            },
          },
          {
            key: 'accountInfo_username',
            title: this.$t('hospital_table_managerid'),
            dataIndex: 'accountInfo_username',
            align: 'start',
            customRender: ({text, record}) => {
              return (
                  <div class="item-names-wrap justify-content-start">
                    {record.accountInfo_username.map((name) => (
                        <div class="item-names">{name || '-'}</div>
                    ))}
                  </div>
              )
            },
          },
        ]
      },
      rowSelection: {
        checkStrictly: false,
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        onSelect: (record, selected, selectedRows) => {
          console.log("1record: ", record, "1selected: ", selected, "1selectedRows: ", selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          console.log("2selected: ", selected, "2selectedRows: ", selectedRows, "2changeRows: ", changeRows);
        },
      }
    }
  },
  methods: {
    ui() {
      return {
        onFinish: async () => {
        },
        onFinishFailed: async () => {
        },
        formatAddress: (input) => {
          const firstText = input.addrOne ? input.addrOne : '';
          const secondText = input.addrTwo ? input.addrTwo : '';
          const thirdText = input.addrThree ? input.addrThree : '';
          const combinedText = `${firstText} ${secondText} ${thirdText}`;
          if (combinedText.trim().length === 0) return '-';
          return combinedText;
        },
      }
    },
    api() {
      return eventApis(this.$apiInstance, this.$store)
    }
  }
}
</script>
<style scoped lang="scss">
@import './event.scss';

@media screen and (max-width: 767px) {
  .row {
    padding: 14px 14px 36px 14px !important
  }
  .event-div-wrap .div905 .black-btn {
    width: auto;
    padding: 10px 5px;
  }
  .event-div-wrap .button-box {
    margin-left: 0;
  }
  .certi-btn-regular {
    padding: 6.5px 9px;
  }
  .w-35 {
    width: 100% !important;
  }
  .event-div-wrap .black-btn {
    width: 100px !important;
    padding: 8px 12px;
  }
  .event-div-wrap .password-area button {
    top: 43px;
  }
  .item-btn-area {
    max-width: none;
  }
  p {
    margin-bottom: 0;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .w-35 {
    width: 50% !important;
  }
  p {
    margin-bottom: 0;
  }
}
</style>
